import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  PopularTag,
  RecentSearch,
  SearchTypes,
  TrendingSearch,
} from '../../../../models/global-search.model';
import { RecentSearchesComponent } from '../recent-searches/recent-searches.component';
import { TrendingSearchesComponent } from '../trending-searches/trending-searches.component';
import { PopularTagsComponent } from '../popular-tags/popular-tags.component';

export interface SearchSuggestion {
  text: string;
  type: SearchTypes;
}

@Component({
  selector: 'app-search-empty-state',
  standalone: true,
  imports: [
    CommonModule,
    RecentSearchesComponent,
    TrendingSearchesComponent,
    PopularTagsComponent,
  ],
  templateUrl: './search-empty-state.component.html',
  styleUrl: './search-empty-state.component.scss',
})
export class SearchEmptyStateComponent {
  @Input() recentSearches: RecentSearch[] = [];
  @Input() trendingSearches: TrendingSearch[] = [];
  @Input() popularTags: PopularTag[] = [];

  /** Emits when user picks any suggestion */
  @Output() searchSelected = new EventEmitter<SearchSuggestion>();
  /** Emits when user removes a single recent search */
  @Output() removeRecent = new EventEmitter<RecentSearch>();
  /** Emits when user clears all recent searches */
  @Output() clearAllRecent = new EventEmitter<void>();

  onRecentSelect(search: RecentSearch) {
    this.searchSelected.emit({ text: search.text, type: search.category });
  }

  onTrendingSelect(keyword: string) {
    this.searchSelected.emit({ text: keyword, type: SearchTypes.all });
  }

  onTagSelect(tag: string) {
    this.searchSelected.emit({ text: tag, type: SearchTypes.all });
  }
}
